module.exports = __webpack_public_path__ + "static/media/care3.5f127c07.JPG";